import { algorithmRunStatuses } from '../../constants/constants'
import {
  AlgorithmRun,
  FlowCytometryNodeResult,
  FlowCytometryReviewAnalysisRunResult,
} from '../../store/reducers/workspaceReducer'

const reviewAnalysisRunResult: FlowCytometryReviewAnalysisRunResult = {
  metadata: {
    runDate: '2026-01-07 10:01:51.163800',
    analysisExperimentId: '69318a5cc646c5b7e3c91636',
    ssrExperimentId: 'N/A',
    ssrFilename: 'qkg_ssr.json',
    attachmentsExperimentIds: [
      '69318b70ceaffb01fa85e837',
      '69318b8a60f72b5b7ee9cbee',
    ],
    totalFlags: 146,
  },
  gateReview: [
    {
      patientId: 'A01-002',
      filename: 'ADO0007P0007P_CTRL_A_F10_006.fcs',
      visit: 'C1D9 24h after SoI',
      exportTime: '28-FEB-2025-21:00:30',
      gateName: 'CD45+SSClow',
      parentPopulation: 'CD45+',
      flagMessage:
        'Polygon bounding box differs on both X and Y axes by more than 5.0%.',
      standardFileRef: 'ADO0001M0005P_FULL_A_B04_001.fcs',
      severity: 'CRITICAL',
      deviationPercent: 50,
    },
    {
      patientId: 'A01-002',
      filename: 'ADO0007P0001P_FULL_A_A09_017.fcs',
      visit: 'C1D9 24h after SoI',
      exportTime: '28-FEB-2025-19:07:08',
      gateName: 'CD45+SSClow',
      deviationPercent: 50,
      parentPopulation: 'CD45+',
      flagMessage:
        'Polygon bounding box differs on both X and Y axes by more than 5.0%.',
      standardFileRef: 'ADO0001M0005P_FULL_A_B04_001.fcs',
      severity: 'CRITICAL',
    },
    {
      patientId: 'A01-002',
      filename: 'ADO0007P0003P_CTRL_A_E09_018.fcs',
      visit: 'C1D9 24h after SoI',
      exportTime: '28-FEB-2025-19:09:06',
      gateName: 'CD45+SSClow',
      deviationPercent: 50,
      parentPopulation: 'CD45+',
      flagMessage:
        'Polygon bounding box differs on both X and Y axes by more than 5.0%.',
      standardFileRef: 'ADO0001M0005P_FULL_A_B04_001.fcs',
      severity: 'CRITICAL',
    },
  ],
  compensationMatrixReview: [
    {
      patientId: 'A01-002',
      filename: 'ADO0001M0001P_FULL_A_A03_005.fcs',
      cytometerId: '001',
      matrixNameFound: 'QNL_QNL-1_CYT006_RCM1',
      flagMessage: 'Flag message mocked',
      severity: 'CRITICAL',
    },
    {
      patientId: 'A01-002',
      filename: 'ADO0001M0003P_CTRL_A_E03_006.fcs',
      cytometerId: '001',
      matrixNameFound: 'QNL_QNL-1_CYT006_RCM1',
      flagMessage: 'Flag message mocked',
      severity: 'CRITICAL',
    },
    {
      patientId: 'A05-002',
      filename: 'ADO0023P0003P_CTRL_NO-STIM_A_E12_042.fcs',
      cytometerId: '006',
      matrixNameFound: 'QNL_QNL-1_CYT001_RCM1',
      flagMessage: 'Flag message mocked',
      severity: 'CRITICAL',
    },
  ],
  gateLockReview: [
    {
      patientId: null,
      filename: 'ADO0010P0001P_FULL_A_A12_023.fcs',
      gatesLocked: false,
      severity: 'CRITICAL',
    },
    {
      patientId: null,
      filename: 'ADO0006P0007P_CTRL_A_F09_004.fcs',
      gatesLocked: false,
      severity: 'CRITICAL',
    },
    {
      patientId: null,
      filename: 'ADO0002P0001P_FULL_A_A04_007.fcs',
      gatesLocked: false,
      severity: 'CRITICAL',
    },
  ],
  additionalFileReview: [
    {
      attachmentName: 'Attachment name hard coded 2',
      checkType: 'Check type hard coded',
      flagMessage:
        'Polygon bounding box differs on both X and Y axes by more than 5.0%.',
    },
  ],
  otherIssues: [
    {
      message:
        "File 'HD_REF.fcs': Contains invalid metadata ('NAP' for patient ID). File will be excluded from analysis.",
    },
    {
      message:
        "INFO for Patient 'A05-002': No explicit standard provided. File 'ADO0014P0001P_FULL_NO-STIM_A_A03_005.fcs' was inferred as standard because it was selected as the only file with the earliest upload time. (Note: This is based on the 'EXPORT TIME' annotation).",
    },
    {
      message:
        "INFO for Patient 'A01-003': No explicit standard provided. File 'ADO0025M0001P_FULL_NO-STIM_A_B01_015.fcs' was inferred as standard because it was selected as the only file with the earliest upload time. (Note: This is based on the 'EXPORT TIME' annotation).",
    },
  ],
}

const nodeResults: FlowCytometryNodeResult = {
  REVIEW_ANALYSIS: reviewAnalysisRunResult,
}

const algorithmRunsArray: AlgorithmRun[] = [
  {
    id: '1',
    workspace: undefined,
    dataSource: undefined,
    runStatus: algorithmRunStatuses.ONGOING_AI,
    outputPath: 'string',
    runResult: reviewAnalysisRunResult,
    nodeResults: nodeResults,
    actionBy: undefined,
    actionDate: '2023-10-05T15:42:41.893Z',
    completedDate: '2023-10-05T15:42:41.893Z',
  },
  {
    id: '2',
    workspace: undefined,
    dataSource: undefined,
    runStatus: algorithmRunStatuses.COMPLETE,
    outputPath: 'string',
    runResult: reviewAnalysisRunResult,
    nodeResults: nodeResults,
    actionBy: undefined,
    actionDate: '2023-10-05T15:42:41.893Z',
    completedDate: '2023-10-05T15:42:41.893Z',
  },
]

export const workspaceAlgorithmRunFlowCytometryMock = algorithmRunsArray[1]
